import { createSlice } from '@reduxjs/toolkit';

import initialState, * as handlers from './handlers';

const isHideVideo = createSlice({
  name: 'isHideVideo',
  initialState,
  reducers: {
    setIsHideVideo: handlers.setIsHideVideo,
  },
});

const { actions } = isHideVideo;

export const { setIsHideVideo } = actions;

export default isHideVideo.reducer;
